import { CarlineWithSalesgroups } from '../../types/vehicle-types';
import { externalContentManager } from '../external-content';
import { fetchCarlinesWithSalesgroups } from './fetch/data-fetch';

export const getCarline = async (nameOrCode?: string | number): Promise<CarlineWithSalesgroups | null> => {
	if (!nameOrCode) return null;

	const response = await fetchCarlinesWithSalesgroups();

	if (response) {
		const carline = response?.find((carline) => carline.name == nameOrCode || carline.code == nameOrCode);

		return carline ?? null;
	}
	return null;
};

// Obtiene carlines desde carlineCode[] y carlineName[]
export const getCarlines = async (): Promise<CarlineWithSalesgroups[] | null> => {
	const carlines = await fetchCarlinesWithSalesgroups();

	if (!carlines) {
		return null;
	}

	const toFilterCarlines = externalContentManager.carlines;

	if (toFilterCarlines) {
		const filteredCarlines = carlines.filter(
			(carline) => toFilterCarlines.includes(carline.name) || toFilterCarlines.includes(String(carline.code)),
		);
		return filteredCarlines.length > 0 ? filteredCarlines : carlines; // Si en el filtrado nos quedamos vacios devolvemos todos los carlines
	} else {
		return carlines;
	}
};
